import { fetchWrapper } from '../../utils';

export class tests {
  static baseUrl = process.env.REACT_APP_BASE_API + 'professor';


  static async getTests(params) {
    const url = `${this.baseUrl}/tests/get`;
    return await fetchWrapper.post(url, params);
  }


  static async createTest(params) {
    const url = `${this.baseUrl}/tests/create`;
    return await fetchWrapper.post(url, params);
  }

  static async editTest(params) {
    const url = `${this.baseUrl}/tests/edit`;
    return await fetchWrapper.post(url, params);
  }

  static async destroyTest(params) {
    const url = `${this.baseUrl}/tests/destroy`;
    return await fetchWrapper.post(url, params);
  }

  static async getIndicators(params) {
    const url = `${this.baseUrl}/tests/indicators`;
    return await fetchWrapper.post(url, params);
  }


  /* Test results */

  static async create(params) {
    const url = `${this.baseUrl}/test-results/create`;
    return await fetchWrapper.post(url, params);
  }

  static async getQuestionsAvg(params) {
    const url = `${this.baseUrl}/test-results/questionsAvg`;
    return await fetchWrapper.post(url, params);
  }

  static async getStudentsScore(params) {
    const url = `${this.baseUrl}/test-results/studentsScore`;
    return await fetchWrapper.post(url, params);
  }

  static async getSubjects(params) {
    const url = `${this.baseUrl}/test-results/subjects`;
    return await fetchWrapper.post(url, params);
  }

  static async generateReport(params) {
    const url = `${this.baseUrl}/test-results/report`;
    return await fetchWrapper.post(url, params);
  }
}
